<template>
  <div class="person_wrap">
    <div class="head_wrap">
      <i>
        <img :src="uinfos&&uinfos.avatar?uinfos.avatar:defImg" :onerror="defImg" alt="">
      </i>
      <span v-text="uinfos.user_nickname?uinfos.user_nickname:uinfos.user_login?uinfos.user_login:''"></span>
    </div>
    <div class="child_wrap">
      <div class="child_menu" v-for="(item,index) in tabli" :key="index" @click="tourls(index)">
        <img :src="item.imgUrl" class='iconImg' alt />
        <span v-text="item.text"></span>
        <img class="icon_or_right" src="@/assets/imgs/icon_or_right.png" alt />
      </div>
    </div>
    <!-- 原有退出登录确认弹窗 -->
    <alertBox v-show='showAlert' :title='title' :Message="alertMessage" @replaceChecked="replace_checked" @sureChecked="sure_checked"></alertBox>

    <!-- 新增：密码修改弹窗 -->
    <div class="pwd-mask" v-show="showPwdModal" @click="closePwdModal"></div>
    <div class="pwd-modal" v-show="showPwdModal">
      <div class="pwd-modal__title">修改密码</div>
      <div class="pwd-modal__form">
        <!-- 原密码输入 -->
        <div class="pwd-item">
          <label>原密码</label>
          <div class="pwd-input-wrap">
            <input :type="showOldPwd ? 'text' : 'password'" v-model="oldPwd" placeholder="请输入原登录密码">
            <em @click="toggleOldPwd">{{showOldPwd?'隐藏':'显示'}}</em>
          </div>
          <p class="pwd-error" v-show="oldPwdErr">{{oldPwdErr}}</p>
        </div>
        <!-- 新密码输入 -->
        <div class="pwd-item">
          <label>新密码</label>
          <div class="pwd-input-wrap">
            <input :type="showNewPwd ? 'text' : 'password'" v-model="newPwd" placeholder="6-18位字母、数字">
            <em @click="toggleNewPwd">{{showNewPwd?'隐藏':'显示'}}</em>
          </div>
          <p class="pwd-error" v-show="newPwdErr">{{newPwdErr}}</p>
        </div>
        <!-- 确认新密码输入 -->
        <div class="pwd-item">
          <label>确认新密码</label>
          <div class="pwd-input-wrap">
            <input :type="showConfirmPwd ? 'text' : 'password'" v-model="confirmPwd" placeholder="请再次输入新密码">
            <em @click="toggleConfirmPwd">{{showConfirmPwd?'隐藏':'显示'}}</em>
          </div>
          <p class="pwd-error" v-show="confirmPwdErr">{{confirmPwdErr}}</p>
        </div>
      </div>
      <div class="pwd-modal__btn">
        <button class="cancel-btn" @click="closePwdModal" :disabled="pwdLoading">取消</button>
        <button class="submit-btn" @click="submitModifyPwd" :disabled="pwdLoading">
          <span v-show="!pwdLoading">确认修改</span>
          <span v-show="pwdLoading">修改中...</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
    import alertBox from '@/components/common/alertBox.vue'
    import { mapState, mapActions } from "vuex";
    export default {
        name: "selfInfo",
        data() {
            return {
                uinfos:{},
                title:'',
                showAlert:false,
                alertMessage:'',
                defImg:require('@/assets/imgs/touxiang.png'),
                total: 0,
                tabli:[
                    {
                        imgUrl:  require('@/assets/imgs/icon1.png'),
                        text: '我的收藏'
                    },
                    {
                        imgUrl:  require('@/assets/imgs/icon2.png'),
                        text: '浏览历史'
                    },
                    // 新增：修改密码菜单项（图标可替换为你的密码图标）
                    {
                        imgUrl:  require('@/assets/imgs/icon_pwd.png'),
                        text: '修改密码'
                    },
                    {
                        imgUrl:  require('@/assets/imgs/icon3.png'),
                        text: '退出登录'
                    }
                ],
                // 新增：密码修改相关数据
                showPwdModal: false, // 密码修改弹窗显示状态
                oldPwd: '', // 原密码
                newPwd: '', // 新密码
                confirmPwd: '', // 确认新密码
                showOldPwd: false, // 原密码显示/隐藏
                showNewPwd: false, // 新密码显示/隐藏
                showConfirmPwd: false, // 确认新密码显示/隐藏
                oldPwdErr: '', // 原密码错误提示
                newPwdErr: '', // 新密码错误提示
                confirmPwdErr: '', // 确认新密码错误提示
                pwdLoading: false // 密码修改提交加载状态
            };
        },
        components: {
            alertBox
        },
        created() {
            this.uinfos=localStorage.getItem('userInfo')?JSON.parse(localStorage.getItem('userInfo')):this.userInfo
        },
        computed: {
            ...mapState([
                'userInfo'
            ])
        },
        methods: {
            ...mapActions(["toLoginOut",'setLoginStus', 'modifyPwd']), // 新增：绑定密码修改Vuex action

            // 原有菜单跳转方法 - 新增修改密码项的点击逻辑
            tourls(index){
                if(index == 0 || index == 1){ // 我的收藏、浏览历史
                    this.$router.push({path: 'collectlist', query: {type:index}});
                }else if(index == 2){ // 新增：修改密码（索引2，对应新增的菜单项）
                    this.openPwdModal();
                }else if(index == 3){ // 退出登录（索引改为3，因新增了修改密码项）
                    this.title='退出登录'
                    this.alertMessage='是否确认要退出当前账号？'
                    this.showAlert=true
                }
            },
            // 原有退出登录相关方法
            sure_checked(){
                this.toLoginOutFn()
            },
            replace_checked(){
                this.showAlert=false
            },
            async toLoginOutFn(){
                const result = await this.toLoginOut();
                this.showAlert=false
                this.setLoginStus(false)
                localStorage.removeItem('iniUrl')
                sessionStorage.removeItem('sinfo')
                this.$router.replace({name:'login'})
            },

            // ---------------------- 新增：密码修改相关方法 ----------------------
            // 打开密码修改弹窗（重置状态，避免数据残留）
            openPwdModal() {
                this.showPwdModal = true;
                // 重置所有密码输入和错误提示
                this.oldPwd = '';
                this.newPwd = '';
                this.confirmPwd = '';
                this.oldPwdErr = '';
                this.newPwdErr = '';
                this.confirmPwdErr = '';
                this.pwdLoading = false;
            },
            // 关闭密码修改弹窗
            closePwdModal() {
                this.showPwdModal = false;
            },
            // 原密码显示/隐藏切换
            toggleOldPwd() {
                this.showOldPwd = !this.showOldPwd;
            },
            // 新密码显示/隐藏切换
            toggleNewPwd() {
                this.showNewPwd = !this.showNewPwd;
            },
            // 确认新密码显示/隐藏切换
            toggleConfirmPwd() {
                this.showConfirmPwd = !this.showConfirmPwd;
            },
            // 密码修改前端校验（统一校验所有项）
            checkPwdForm() {
                let isPass = true;
                // 1. 原密码校验
                if (!this.oldPwd) {
                    this.oldPwdErr = '请输入原密码';
                    isPass = false;
                } else {
                    this.oldPwdErr = '';
                }
                // 2. 新密码校验（与注册/登录密码规则一致）
                if (!this.newPwd) {
                    this.newPwdErr = '请输入新密码';
                    isPass = false;
                } else if (!/^[a-zA-Z0-9_]{6,18}$/.test(this.newPwd)) {
                    this.newPwdErr = '新密码为6-18位字母、数字';
                    isPass = false;
                } else {
                    this.newPwdErr = '';
                }
                // 3. 确认新密码校验
                if (!this.confirmPwd) {
                    this.confirmPwdErr = '请再次输入新密码';
                    isPass = false;
                } else if (this.confirmPwd !== this.newPwd) {
                    this.confirmPwdErr = '两次输入的密码不一致';
                    isPass = false;
                } else {
                    this.confirmPwdErr = '';
                }
                return isPass;
            },
            // 提交密码修改（核心方法）
            async submitModifyPwd() {
                // 1. 前端先校验，校验失败直接返回
                if (!this.checkPwdForm()) return;
                // 2. 设置加载状态，防止重复提交
                this.pwdLoading = true;
                try {
                    // 3. 组装请求参数（手机号从本地用户信息获取，登录名=手机号）
                    const mobile = this.uinfos.mobile || this.userInfo.mobile;
                    const params = {
                        //mobile: mobile, // 手机号（后端用于标识用户）
                        username: mobile, // 手机号（后端用于标识用户）
                        old_pwd: this.oldPwd, // 原密码
                        new_pwd: this.newPwd  // 新密码
                    };
                    // 4. 调用Vuex的密码修改action（对接后端接口）
                    const res = await this.modifyPwd(params);
                    // 5. 处理成功结果
                    if (res.code === '1') {
                        this.$toast('密码修改成功，请重新登录');
                        this.closePwdModal();
                        // 密码修改成功后，建议退出登录让用户重新登录（保证状态同步）
                        this.toLoginOutFn();
                    } else {
                        // 6. 处理失败结果（后端返回的错误，如原密码错误）
                        this.$toast(res.msg);
                    }
                } catch (err) {
                    // 网络错误/接口异常
                    this.$toast('密码修改失败，请稍后重试');
                    console.error('密码修改请求异常：', err);
                } finally {
                    // 7. 无论成功/失败，关闭加载状态
                    this.pwdLoading = false;
                }
            }
        }
    };
</script>

<style scoped>
  /* 原有样式保留 */
  .head_wrap{
    display:flex;
    flex-direction:column;
    align-items:center;
    height:235.5px;
    background-repeat:no-repeat;
    background-position:0 0;
    background-image:url('../assets/imgs/bg.png');
    background-size:100%;
    font-size:13px;
    color:#fff;
    margin-bottom:23px;
  }
  .head_wrap i{
    margin-top:41px;
    width:68px;
    height:68px;
  }
  .head_wrap i img{
    width:66px;
    height:66px;
    background:#82ca9c;
    border:2px solid #ffffff;
    border-radius:50%;
  }
  .head_wrap span{
    margin-top:14px;
    color:#FEFEFE;
  }
  .child_wrap{
    margin:0 14px 50px 12px;
    background-color:#fff;
  }
  .child_wrap .child_menu{
    position:relative;
    font-size:14px;
    color:#333;
    display:flex;
    justify-content:flex-start;
    align-items:center;
    margin-bottom:22px;
    padding: 10px 0; /* 优化：增加内边距，扩大点击区域 */
  }
  .icon_or_right{
    position:absolute;
    right:0;
    width:7px;
  }
  .iconImg{
    width:25px;
    margin-right:15px;
  }

  /* 新增：密码修改弹窗样式（与原有风格统一，适配移动端） */
  /* 弹窗遮罩 */
  .pwd-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 99;
  }
  /* 弹窗主体 */
  .pwd-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 300px;
    background: #fff;
    border-radius: 8px;
    z-index: 100;
    padding: 20px;
    box-sizing: border-box;
  }
  /* 弹窗标题 */
  .pwd-modal__title {
    font-size: 16px;
    color: #333;
    text-align: center;
    margin-bottom: 20px;
    font-weight: 500;
  }
  /* 表单容器 */
  .pwd-modal__form {
    margin-bottom: 25px;
  }
  /* 密码输入项 */
  .pwd-item {
    margin-bottom: 15px;
  }
  .pwd-item label {
    display: block;
    font-size: 14px;
    color: #666;
    margin-bottom: 8px;
    text-align: left;
  }
  /* 密码输入框容器 */
  .pwd-input-wrap {
    position: relative;
    border: 1px solid #eee;
    border-radius: 4px;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 10px;
  }
  .pwd-input-wrap input {
    flex: 1;
    height: 100%;
    border: none;
    outline: none;
    font-size: 14px;
    color: #333;
  }
  .pwd-input-wrap em {
    font-size: 12px;
    color: #00878b;
    cursor: pointer;
    user-select: none;
  }
  /* 密码错误提示 */
  .pwd-error {
    font-size: 12px;
    color: #F34740;
    margin-top: 5px;
    margin-bottom: 0;
    line-height: 1;
  }
  /* 弹窗按钮容器 */
  .pwd-modal__btn {
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }
  .pwd-modal__btn button {
    flex: 1;
    height: 40px;
    border: none;
    outline: none;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
  }
  /* 取消按钮 */
  .cancel-btn {
    background: #dedede;
    color: #666;
  }
  /* 确认修改按钮 */
  .submit-btn {
    background: #00878b;
    color: #fff;
  }
  /* 加载状态禁用样式 */
  .pwd-modal__btn button:disabled {
    opacity: 0.6;
    pointer-events: none;
  }
</style>


// WEBPACK FOOTER //
// src/components/selfInfo.vue